/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiLeadLinkTypeFromJSON, ApiLeadLinkTypeToJSON, } from './ApiLeadLinkType';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiLeadLinkFromJSON(json) {
    return ApiLeadLinkFromJSONTyped(json, false);
}
export function ApiLeadLinkFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'externalId': !exists(json, 'externalId') ? undefined : json['externalId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'leadId': !exists(json, 'leadId') ? undefined : json['leadId'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'type': !exists(json, 'type') ? undefined : ApiLeadLinkTypeFromJSON(json['type']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiLeadLinkToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'externalId': value.externalId,
        'id': value.id,
        'leadId': value.leadId,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'type': ApiLeadLinkTypeToJSON(value.type),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
